(function (scope) {
  'use strict';
  const weights = {sandalo:32,oud:14,cedro:26,vetiver:20,pachuli:15,cuero:14,ambar:27,incienso:12,mirra:10,benjui:16,almizcle:30,tabaco:18,bergamota:28,naranja:23,mandarina:25,limon:21,lavanda:24,salvia:16,cardamomo:13,pimienta_negra:7,canela:9,jengibre:12,jazmin:26,iris:22,azahar:24,heliotropo:20,vainilla:29,tonka:21,almendra:19,cacao:15};
  // Neutral starting weights for editable proposals, never a formulation recipe.
  for (const id of ['rosa','pimienta_rosa','ylang_ylang','labdano','geranio','violeta','toronja','nardo','petitgrain','azafran','lirio_del_valle','musgo_de_roble','guayaco','nuez_moscada','pera','romero','peonia','gardenia','galbano','bayas_enebro','estragon','lirio','tomillo','papiro','cereza','te_negro','ciruela','grosella_negra','miel','acorde_marino']) weights[id] = 20;
  function suggest(ids, custom) {
    const unique = [...new Set(ids)].filter(id => Object.hasOwn(weights, id));
    if (!unique.length) return [];
    const values = unique.map(id => Number(custom && custom[id]) > 0 ? Number(custom[id]) : weights[id]);
    const total = values.reduce((a,b) => a+b, 0);
    const parts = unique.map((id,i) => ({id, percent:1+Math.floor(values[i]/total*(100-unique.length)), fraction:values[i]/total*(100-unique.length)%1}));
    const order = parts.slice().sort((a,b) => b.fraction-a.fraction);
    let remaining = 100-parts.reduce((n,p) => n+p.percent,0);
    for (let i=0;remaining>0;i++,remaining--) order[i%order.length].percent++;
    return parts.map(({id,percent}) => ({id,percent}));
  }
  function cap(selected, id, value) {
    const others=selected.filter(p=>p.id!==id).reduce((sum,p)=>sum+(Number(p.percent)||0),0);
    const parsed=/^\d+$/.test(String(value)) ? Number(value) : 0;
    return Math.min(Math.max(0,100-others),Math.max(0,Number.isSafeInteger(parsed)?parsed:0));
  }
  const api={suggest,cap,weights};
  if(typeof module!=='undefined') module.exports=api;
  scope.ExEBlend=api;
})(typeof window==='undefined'?globalThis:window);

